<template>
    <div>
      <hp5-spacing-vertical xs="xxs" xl="xxs" md="xxs" lg="xxs" sm="xxs"></hp5-spacing-vertical>
      <div v-if="isPrimaryCareClinic">
        <hp5-semantic size-selection="sm"><b>This is your primary care clinic</b></hp5-semantic>
      </div>
      <div v-if="isEligibleToChange">
        <hp5-link-text-basic
        :data-card-rank="rank"
        v-if="isAllowedAsPrimaryClinic && !isPrimaryCareClinic"
        v-on:click="showModal"
        text="Make this my primary care clinic"
        size="sm" />
      </div>


      <!--modal to change primary care clinic-->
      <hp5-modal-basic
        v-on:confirmed="handleClose"
        modal-id=""
        ref="modalrefPCC"
        confirm-button-hidden="true"
        title-text="Do you want to change your primary care clinic?"
        title-size-selection="md"
        body-size-selection="md"
        :visible="isVisible"
        dismissible="true"
        always-dismiss="false"
      >
      <hp5-semantic>
        <p>Doing so could change your care system's network. This may change your in-network options, benefits and copays.</p>
        <div class="buttonContainer">
          <hp5-button-decorator type="secondary" size="md">
            <button type="button" v-on:click="handleClose">No, cancel</button>
          </hp5-button-decorator>
            <hp5-call-to-action
            :href="changePrimaryClinicUrl"
            size="md"
            text="Yes, continue"
            type="primary"
        />
        </div>
        <hp5-spacing-vertical xs="md"></hp5-spacing-vertical>
      </hp5-semantic>
    </hp5-modal-basic>
    </div>
</template>
  
<script setup>

    const props = defineProps({
        location: Object,
        rank: Number
    })

    let isVisible = ref(false)
    const { profile, context, plan } = useFCPModel()
    const { buildUrl } = useUrls(context.value)
    const changePrimaryClinicUrl = computed(() => buildUrl('/fcp/change-primary-clinic/', { newLocationId: props.location.id }))
    const isPrimaryCareClinic = computed(() =>
        plan.value && plan.value.primaryCareClinic ? plan.value.primaryCareClinic.id == props.location.id : false
    )
    
    const showModal = () => {
        isVisible.value = true
    }

    const handleClose = () => {
      isVisible.value = false;
};

    const planType = computed(() => plan.value)
  
    const isAllowedAsPrimaryClinic = computed(() => {
      if (context.value.type != 'medical') return false

      if (!profile.value.isAuthenticated) return false
      if (planType.value.practiceType != props.location.practiceType) return false
      if (!plan.value.primaryCareClinic) return false
      if (!props.location.externalClinicId) return false
      if (props.location.externalClinicId == 'This clinic is not available for Primary Care enrollment') return false
      if (!props.location.acceptingNewPatients) return false

      return true
         
    })

    const isEligibleToChange = computed(() => {
      return plan.value &&  plan.value.primaryCareClinic && plan.value.primaryCareClinic.isEligibleToChange
    })
  
  </script>
  
  <style scoped lang="scss">
  @use '../../../assets/scss/breakpoints' as *;
  
  @include small-up {
    .info-and-estimates {
      display: grid;
      grid-template-columns: auto auto;
      column-gap: var(--spacing-md);
    }
  }
  .bottom-panel {
    display: flex;
    margin-top: var(--spacing-sm);
  
    .toggle {
      align-self: center;
    }
  }
  
  .buttonContainer {
    float: right;
  
    button {
      margin-right: 18px;
      width: 125px;
    }
  }
  </style>
  <style lang="scss">
  hp5-modal-basic .modal-basic-wrapper .modal-header button {
    margin:0;
  }
  </style>